// extracted by mini-css-extract-plugin
module.exports = {"video":"styles_video__JhhYm","button":"styles_button__16pg1"};